
  <h1>{{ 'T4.Campaign.VoucherDialog.Headline' | translate : 'Voucher list' }}</h1>
  <div class="turboContainer">
    <a href="{{result.VoucherUrl}}" target="_blank">{{'T4.Campaign.PrintVouchersDialog' | translate : 'Print vouchers'}}</a>
  </div>
  <br/>
  <t4-container height="500px">
    <t4-data-table #tblVouchers [allowFilter]="true" [rawData]="result.VoucherCodes" headline="{{'T4.Campaigns.DialogList.lblvoudcherlist' | translate : 'Vouchers' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['campaigncode']">
      <ng-container matColumnDef="vourchercode">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;">{{'T4.Campaigns.Campaign.lblvouchercode' |translate : 'Voucher code' }}</mat-header-cell>     
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:50px;"><mat-icon style="color: black">confirmation_number</mat-icon>&nbsp;{{row}} </mat-cell>
      </ng-container>
    </t4-data-table>
  </t4-container>
